/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Error_Idempotency_Key_RequiredInputs */

const vi_error_idempotency_key_required = /** @type {(inputs: Error_Idempotency_Key_RequiredInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Yêu cầu đặt đơn thiếu mã chống gửi trùng (Idempotency-Key). Gửi lại kèm mã này.`)
};

/**

* @param {Error_Idempotency_Key_RequiredInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const error_idempotency_key_required = /** @type {((inputs?: Error_Idempotency_Key_RequiredInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Error_Idempotency_Key_RequiredInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_error_idempotency_key_required(inputs)
});